import { Dropdown, MenuProps } from 'antd';
import classNames from 'classnames';
import { MenuInfo } from 'rc-menu/lib/interface';
import { useTranslation } from 'react-i18next';

import { DownOutlined } from '@ant-design/icons';
import { SortBy } from '@common/enums';
import i18n from '@core/i18n/i18n';

import './sort-by-menu.scss';

interface SortByMenuProps {
    options: SortBy[];
    sortBy?: SortBy;

    /**
     * TODO: This is the new way of passing the dispatcher function via 'props' using redux
     *  remove the '?' after all components that use this component are migrated to redux
     */
    setSortingOption?: (e: MenuInfo) => void;

    /**
     * @deprecated see setSortingOption
     * TODO: this 'prop' is now optional to be backwards-compatible with
     *  passing the 'setter' function from the parent component's local state.
     *  Remove this once all components that use this component are migrated to redux
     */
    setSortBy?: (sortBy?: SortBy) => void;
}

export const SortByMenu = ({
    options,
    sortBy = SortBy.None,
    setSortingOption,
    setSortBy,
}: SortByMenuProps): JSX.Element => {
    const { t } = useTranslation();

    const useReduxSetter = !!setSortingOption;

    const defaultSortByTitle = 'COMMON.SORT_BY';
    const menuTitleByKey = {
        [SortBy.LowToHigh]: `${i18n.t(defaultSortByTitle)}: ${i18n.t(SortBy.LowToHigh)}`,
        [SortBy.HighToLow]: `${i18n.t(defaultSortByTitle)}: ${i18n.t(SortBy.HighToLow)}`,
        [SortBy.NameAZ]: `${i18n.t(defaultSortByTitle)}: ${i18n.t(SortBy.NameAZ)}`,
        [SortBy.NameZA]: `${i18n.t(defaultSortByTitle)}: ${i18n.t(SortBy.NameZA)}`,
        [SortBy.TrendingNow]: `${i18n.t(defaultSortByTitle)}: ${i18n.t(SortBy.TrendingNow)}`,
        [SortBy.None]: `${i18n.t(defaultSortByTitle)}`,
    };

    const items: MenuProps['items'] = options.map((option) => ({
        key: option,
        label: (
            <div className={classNames({ selected: sortBy === option })} key={option}>
                {t(option)}
            </div>
        ),
    }));

    return (
        <Dropdown
            className="SortByMenu"
            menu={{
                onClick: useReduxSetter ? setSortingOption : (e) => setSortBy?.(e.key as unknown as SortBy),
                items,
            }}
        >
            <a className="ant-dropdown-link SortByMenu__menu-title" onClick={(e) => e.preventDefault()}>
                {menuTitleByKey[sortBy]} <DownOutlined className="SortByMenu__arrow" />
            </a>
        </Dropdown>
    );
};
